export const PAYMENT_TASK_STATUS = {
  PENDING: 'PENDING',
  PROCESSING: 'PROCESSING',
  SUCCEEDED: 'SUCCEEDED',
  FAILED: 'FAILED',
  CANCELLED: 'CANCELLED',
  CORRECTED: 'CORRECTED',
} as const;

export const PAYMENT_ATTEMPT_STATUS = {
  PROCESSING: 'PROCESSING',
  SUCCEEDED: 'SUCCEEDED',
  FAILED: 'FAILED',
  CORRECTED: 'CORRECTED',
} as const;

export type PaymentTaskStatus = (typeof PAYMENT_TASK_STATUS)[keyof typeof PAYMENT_TASK_STATUS];
export type PaymentAttemptStatus =
  (typeof PAYMENT_ATTEMPT_STATUS)[keyof typeof PAYMENT_ATTEMPT_STATUS];

export const COLLECTION_STATUS = {
  PENDING_CONFIRMATION: 'PENDING_CONFIRMATION',
  CONFIRMED: 'CONFIRMED',
  REJECTED: 'REJECTED',
  CORRECTED: 'CORRECTED',
} as const;

export type CollectionStatus = (typeof COLLECTION_STATUS)[keyof typeof COLLECTION_STATUS];

export const PAYMENT_CORRECTION_STATUS = {
  PENDING_REVIEW: 'PENDING_REVIEW',
  APPROVED: 'APPROVED',
  REJECTED: 'REJECTED',
} as const;

export type PaymentCorrectionStatus =
  (typeof PAYMENT_CORRECTION_STATUS)[keyof typeof PAYMENT_CORRECTION_STATUS];
